import Echo from 'laravel-echo';
import { getAuthorization } from 'utils/common';
import { socketUrl } from 'config/env.config';

const socketConnect = () => {
  window.Echo = new Echo({
    broadcaster: 'socket.io',
    host: socketUrl,
    transports: ['websocket', 'polling', 'flashsocket'],
    auth: {
      headers: {
        Authorization: getAuthorization(),
      }
    }
  });
};

export default socketConnect;



// WEBPACK FOOTER //
// ./src/utils/socketConnect.js